// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3bj04","footer":"ModalCreateQualiphyProcedure_footer__1yxhu","additionData":"ModalCreateQualiphyProcedure_additionData__-3Gqy"};